// @flow
import type { Product } from 'digicel-kaizen-library';
import type { StateType } from '../reducers';

export const promoProductsSelector = (state: StateType): Product[] => state.promoProducts || [];

export const promoProductBySubscriptionOuidAndTimestampSelector = (
  state: StateType,
  subscriptionOuid: string,
  timestamp: number
): ?Product => {
  const subscriptionPromoProducts = promoProductsSelector(state).filter(product =>
    product.productRelationships.some(
      relationship => relationship.type === 'PARENT' && relationship.targetProductOuid === subscriptionOuid
    )
  );

  let subscriptionPromoProduct;

  subscriptionPromoProducts.forEach(product => {
    if (
      !subscriptionPromoProduct ||
      Math.abs(product.dateTimeCreate - timestamp) < Math.abs(subscriptionPromoProduct.dateTimeCreate - timestamp)
    )
      subscriptionPromoProduct = product;
  });

  return subscriptionPromoProduct;
};
